module.exports = __webpack_public_path__ + "media/images/logos/logo_large-76e21e51f53aa7fd4cf5fd48004d9267.png";